import script from "./EntityTypeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityTypeSelector.vue?vue&type=script&setup=true&lang=js"

import "./EntityTypeSelector.vue?vue&type=style&index=0&id=a095e2fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a095e2fe"]])

export default __exports__